import { graphql, Slice } from 'gatsby';
import React from 'react';

import Default from '~/templates/Default';

import Seo from '~/layout/SEO';

import LocationHeader from '~/components/LocationHeader';

const Location = ({ data }) => {
    const {
        yextLocation: {
            id,
            address,
            mainPhone,
            hours,
            facebookPageUrl,
            twitterHandle,
            instagramHandle,
            photoGallery: photos,
            comingSoon
        }
    } = data;

    return (
        <Default>
            <LocationHeader
                locationID={id}
                {...{
                    address,
                    mainPhone,
                    hours,
                    facebookPageUrl,
                    twitterHandle,
                    instagramHandle,
                    photos,
                    comingSoon
                }}
            />
            <Slice alias="location-page-blocks" />
        </Default>
    );
};

export default Location;

export const Head = ({
    location,
    data: {
        yextLocation: {
            address: { line1, city, region },
            photoGallery: photos
        }
    }
}) => {
    const image = photos?.length ? photos[0].image.url : '';
    return (
        <Seo
            {...{ location, image }}
            title={`${line1} ${city}, ${region} - Autobell`}
        />
    );
};

export const query = graphql`
    query Location($id: String!) {
        yextLocation(id: { eq: $id }) {
            id
            address {
                line1
                city
                region
                postalCode
            }
            mainPhone
            facebookPageUrl
            twitterHandle
            instagramHandle
            comingSoon
            photoGallery {
                image {
                    url
                }
            }
            hours {
                monday {
                    openIntervals {
                        start
                        start
                        end
                    }
                }
                tuesday {
                    openIntervals {
                        start
                        end
                    }
                }
                wednesday {
                    openIntervals {
                        start
                        end
                    }
                }
                thursday {
                    openIntervals {
                        start
                        end
                    }
                }
                friday {
                    openIntervals {
                        start
                        end
                    }
                }
                saturday {
                    openIntervals {
                        start
                        end
                    }
                }
                sunday {
                    openIntervals {
                        start
                        end
                    }
                }
            }
        }
    }
`;
